import styled from 'styled-components';
import { colors, fonts, spacing } from 'ui/theme';

export const Cell = styled.div<{ columnId: string }>`
  grid-column: col-${({ columnId }) => columnId} / span 1;
  padding: 15px ${spacing.plusHalf};
  display: flex;
  flex-direction: column;
  font-family: ${fonts.sansSerif};
  justify-content: center;
  &.shadedRow {
    background-color: ${colors.backgroundSecondary};
  }
`;
